module.exports = __webpack_public_path__ + "img/b4-1.a7c25bc.png";